import { TextVariants } from '@lichtblick/theme';
import { GetWorkOrderAppointmentsPayloadModel } from '@lichtblick/types';

import { TDWrapper, Container, AppointmentWrapper, ArrowForwardOutlinedIcon } from './WorkOrderAppointmentItem.styles';

import { Appointment } from '../Appointment';
import { Text } from '../Text';

type WorkOrderAppointmentItemProps = {
  appointment: NonNullable<GetWorkOrderAppointmentsPayloadModel>;
  onNavigate: () => void;
};

export const WorkOrderAppointmentItem = ({ appointment, onNavigate }: WorkOrderAppointmentItemProps) => {
  const { endDateUtc, startDateUtc, type } = appointment;
  const partners = appointment.partnerCompanies?.map((comp) => comp.name) ?? [];
  const users = appointment.craftsmen?.map((user) => `${user.firstName} ${user.lastName}`) ?? [];
  const members = [...partners, ...users];

  return (
    <Container onClick={() => onNavigate()}>
      <AppointmentWrapper>
        <Appointment
          endDate={endDateUtc}
          isBinding={appointment.isBinding}
          startDate={startDateUtc}
          variant={type ?? 'B'}
        />
      </AppointmentWrapper>
      <TDWrapper $hasDivider>
        <Text $variant={TextVariants.body.m}>{appointment.branchOffice?.name}</Text>
      </TDWrapper>
      <TDWrapper $hasDivider>
        <Text $variant={TextVariants.body.m}>{appointment.comment}</Text>
      </TDWrapper>
      <TDWrapper>
        <Text $variant={TextVariants.body.m}>{members.join(', ')}</Text>
      </TDWrapper>
      <TDWrapper>{<ArrowForwardOutlinedIcon />}</TDWrapper>
    </Container>
  );
};
